
import React from 'react';

const LocationsSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">九州3拠点で随時開催</h2>
          <p className="text-xl sm:text-lg text-gray-600">お近くの教習所でご受講いただけます</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col min-h-[400px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">IDS佐賀教習所</h3>
            <p className="text-lg text-gray-600 mb-4">株式会社アイテム</p>
            
            <div className="flex-1 flex flex-col justify-center">
              <a href="tel:0952-71-9855" className="inline-flex items-center justify-center text-3xl font-bold text-[#2A6041] hover:text-[#76B947] transition-colors cursor-pointer mb-4">
                <i className="ri-phone-line mr-2"></i>
                0952-71-9855
              </a>
              
              <div className="space-y-2 text-gray-600 mb-6">
                <p className="text-sm">佐賀県多久市北多久町大字小侍4771</p>
                <p className="text-sm">対応：佐賀県西部・中山間地域</p>
                <p className="text-xs text-gray-500">※農業ドローン協議会登録名義</p>
              </div>
              
              <a href="/locations#saga" className="inline-flex items-center justify-center bg-[#76B947] text-white px-6 py-3 rounded-lg hover:bg-[#2A6041] transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-map-pin-line mr-2"></i>
                拠点詳細
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col min-h-[400px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">IDS川副教習所</h3>
            <p className="text-lg text-gray-600 mb-4">九三エンジニアリング株式会社</p>
            
            <div className="flex-1 flex flex-col justify-center">
              <a href="tel:0952-97-5291" className="inline-flex items-center justify-center text-3xl font-bold text-[#2A6041] hover:text-[#76B947] transition-colors cursor-pointer mb-4">
                <i className="ri-phone-line mr-2"></i>
                0952-97-5291
              </a>
              
              <div className="space-y-2 text-gray-600 mb-6">
                <p className="text-sm">佐賀県佐賀市川副町小々森146-1</p>
                <p className="text-sm">対応：佐賀県東部・福岡県南部</p>
                <p className="text-xs text-gray-500">※IDS佐賀教習所名義で実施</p>
              </div>
              
              <a href="/locations#kawasoe" className="inline-flex items-center justify-center bg-[#76B947] text-white px-6 py-3 rounded-lg hover:bg-[#2A6041] transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-map-pin-line mr-2"></i>
                拠点詳細
              </a>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow h-full flex flex-col min-h-[400px]">
            <div className="w-16 h-16 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-map-pin-line text-3xl text-[#76B947]"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#2A6041] mb-4">IDS鹿児島教習所</h3>
            <p className="text-lg text-gray-600 mb-4">株式会社エコナーセリー</p>
            
            <div className="flex-1 flex flex-col justify-center">
              <a href="tel:099-213-9466" className="inline-flex items-center justify-center text-3xl font-bold text-[#2A6041] hover:text-[#76B947] transition-colors cursor-pointer mb-4">
                <i className="ri-phone-line mr-2"></i>
                099-213-9466
              </a>
              
              <div className="space-y-2 text-gray-600 mb-6">
                <p className="text-sm">鹿児島県日置市伊集院町古城795</p>
                <p className="text-sm">対応：鹿児島県全域</p>
                <p className="text-xs text-gray-500">※IDS佐賀教習所名義で実施</p>
              </div>
              
              <a href="/locations#kagoshima" className="inline-flex items-center justify-center bg-[#76B947] text-white px-6 py-3 rounded-lg hover:bg-[#2A6041] transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-map-pin-line mr-2"></i>
                拠点詳細
              </a>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <p className="text-lg text-gray-600">
            <strong>受付：全拠点 平日9:00-17:00</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default LocationsSection;
